module.exports = __webpack_public_path__ + "img/icos4.a458fdd8.svg";